'use client';

import { Button } from '@holistic/components';
import { ShieldCheck } from '@holistic/components/icons';

import type { ActiveWarrantyBySerialResponse } from '@/types/warranty';

type WarrantySuggestionProps = {
  warranty: ActiveWarrantyBySerialResponse;
  remainingDays: number;
  onAccept: () => void;
  onDismiss: () => void;
};

const WarrantySuggestion = ({
  warranty,
  remainingDays,
  onAccept,
  onDismiss,
}: WarrantySuggestionProps) => (
  <div className="rounded-2xl border border-emerald-100 bg-emerald-50/60 p-4">
    <div className="flex items-start gap-3.5">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
        <ShieldCheck className="size-4.5" />
      </span>

      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-emerald-900">
          Bu cihazın garantisi var
        </p>
        <p className="mt-0.5 truncate text-xs text-emerald-800/90">
          {warranty.modelName ?? 'Cihaz'} · {warranty.requestTypeName}
        </p>

        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-emerald-700/80">
          <span className="rounded-full bg-emerald-100/80 px-2 py-0.5 font-medium text-emerald-800">
            {remainingDays} gün kaldı
          </span>
          <span>
            Bitiş: {new Date(warranty.endDate).toLocaleDateString('tr-TR')}
          </span>
        </div>

        {warranty.coverageInfo && (
          <p className="mt-2 text-[11px] text-emerald-700/70">
            {warranty.coverageInfo}
          </p>
        )}

        <div className="mt-3.5 flex flex-wrap items-center gap-2">
          <Button
            type="button"
            size="sm"
            className="rounded-full bg-emerald-600 px-4 text-xs font-semibold text-white hover:bg-emerald-700"
            onClick={onAccept}
          >
            Garantiden gönder
          </Button>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className="rounded-full px-3 text-xs text-emerald-700 hover:bg-emerald-100 hover:text-emerald-900"
            onClick={onDismiss}
          >
            Şimdi değil
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default WarrantySuggestion;
